import React from "react";
import { FormattedMessage, FormattedHTMLMessage, useIntl } from "react-intl";

import Seo from "../../../common/helpers/seo";
import { testModerationCategoriesList } from "../../../common/parameters";

import { StyledSpring, Categories } from "./styles";
import messages from "./messages";

const ModerationArticle = () => {
    const { formatMessage } = useIntl()
    return (
        <StyledSpring withShadow marginTop={50}>
            <Seo
                title={formatMessage(messages.title)}
                type={"article"}
                description={formatMessage(messages.description)}
            />
            <h1>
                <FormattedMessage {...messages.title} />
            </h1>
            <p>
                <FormattedMessage {...messages.description} />
            </p>
            <Categories>
                {testModerationCategoriesList.map(category => (
                    <div>
                        <h2>
                            <FormattedMessage {...messages[`${category}`]}/>
                        </h2>
                        <p>
                            <FormattedHTMLMessage {...messages[`${category}Description`]}/>
                        </p>
                    </div>
                ))}
            </Categories>
        </StyledSpring>
    )
}

export default ModerationArticle;
